export default {
  "NODE_ENV": process.env.NODE_ENV,
  "BASE_URL": process.env.REACT_APP_BASE_URL,
  "HOME_URL": process.env.REACT_APP_HOME_URL,
  "DASHBOARD_URL": process.env.REACT_APP_DASHBOARD_URL
}
